<template>
  <label class="form-input-textarea">
    <slot />

    <textarea rows="5"
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
    />
  </label>
</template>

<script>
export default {
  name: 'VFormInputTextarea',
  inheritAttrs: false,
};
</script>

<style lang="scss" scoped>
.form-input-textarea {
  display: block;

  textarea {
    display: block;
    width: 100%;
    padding: calc($gridGutter / 2);

    font-family: $fontFamily;
    font-size: $formInputFontSize;

    border: none;
    outline: none;
    resize: none;

    &::-webkit-input-placeholder {
      color: inherit;
    }

    &::-moz-placeholder {
      color: inherit;
    }

    &:-ms-input-placeholder {
      color: inherit;
    }

    &:-moz-placeholder {
      color: inherit;
    }
  }
}
</style>
